import { render } from "./DragDrop.vue?vue&type=template&id=23a9084f&scoped=true"
import script from "./DragDrop.vue?vue&type=script&lang=js"
export * from "./DragDrop.vue?vue&type=script&lang=js"

import "./DragDrop.vue?vue&type=style&index=0&id=23a9084f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a9084f"]])

export default __exports__